import { createSlice } from "@reduxjs/toolkit";

export const get_pests = createSlice({
  name: "pests_info",
  initialState: {
    value: { status: false, data: [] },
  },
  reducers: {
    updateStorePests: (state, action) => {
      state.value.status = true;
      state.value.data = action.payload;
    },
  },
});

export const { updateStorePests } = get_pests.actions;

export default get_pests.reducer;
